import { useState } from "react";
import { Loader2, Check } from "lucide-react";
import { http, errText } from "../lib/api";

export const WaitlistForm = ({ tone = "dark" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ loading: false, done: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, done: false, error: "" });
    try {
      await http.post("/waitlist", { email });
      setState({ loading: false, done: true, error: "" });
      setEmail("");
    } catch (err) {
      setState({ loading: false, done: false, error: errText(err) });
    }
  };

  const light = tone === "light";
  if (state.done) {
    return (
      <div data-testid="waitlist-success" className={`flex items-center gap-3 font-display uppercase text-2xl ${light ? "text-[#0B0B0B]" : "text-white"}`}>
        <span className="bg-[#E10600] text-white p-2"><Check className="w-5 h-5" /></span> You're on the list. Stay ready.
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="w-full max-w-xl" data-testid="waitlist-form">
      <div className={`flex flex-col sm:flex-row border-2 ${light ? "border-[#0B0B0B]" : "border-white"}`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="YOUR EMAIL"
          data-testid="waitlist-email-input"
          className={`flex-1 bg-transparent px-5 py-4 font-mono-x text-sm tracking-widest outline-none ${light ? "text-[#0B0B0B] placeholder:text-zinc-500" : "text-white placeholder:text-zinc-400"}`}
        />
        <button
          type="submit"
          disabled={state.loading}
          data-testid="waitlist-submit-button"
          className="bg-[#E10600] text-white px-7 py-4 font-display uppercase text-lg tracking-wide flex items-center justify-center gap-2 transition-colors duration-200 hover:bg-white hover:text-[#E10600] disabled:opacity-60"
        >
          {state.loading && <Loader2 className="w-4 h-4 animate-spin" />} Notify me
        </button>
      </div>
      {state.error && <p data-testid="waitlist-error" className="mt-3 text-sm font-semibold text-[#E10600]">{state.error}</p>}
    </form>
  );
};
